import { render, staticRenderFns } from "./Segment.vue?vue&type=template&id=143a510c&"
import script from "./Segment.vue?vue&type=script&lang=js&"
export * from "./Segment.vue?vue&type=script&lang=js&"
import style0 from "./Segment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports